import { render, staticRenderFns } from "./StatisticalCells.vue?vue&type=template&id=2b17fd1a&scoped=true"
import script from "./StatisticalCells.ts?vue&type=script&lang=ts&external"
export * from "./StatisticalCells.ts?vue&type=script&lang=ts&external"
import style0 from "./StatisticalCells.scss?vue&type=style&index=0&id=2b17fd1a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b17fd1a",
  null
  
)

export default component.exports